export default __webpack_public_path__ + "static/sdk_logo-0ea4c4e7d95b489bd36970ec262aae90.gif";